export var TypeActionShop;
(function (TypeActionShop) {
    TypeActionShop["RequestUpdate"] = "Shop > RequestUpdate";
    TypeActionShop["RequestShiftLevelUpdate"] = "Shop > RequestShiftLevelUpdate";
    TypeActionShop["UpdateShiftLevel"] = "Shop > UpdateShiftLevel";
    TypeActionShop["CharacteristicsReceived"] = "Shop > CharacteristicsReceived";
    TypeActionShop["CatalogReceived"] = "Shop > CatalogReceived";
    TypeActionShop["ShiftLevelReceived"] = "Shop > ShiftLevelReceived";
    TypeActionShop["RequestPurchase"] = "Shop > RequestPurchase";
    TypeActionShop["SelectOffer"] = "Shop > SelectOffer";
    TypeActionShop["OpenOffer"] = "Shop > OpenOffer";
})(TypeActionShop || (TypeActionShop = {}));
export var actionShopRequestUpdate = function () { return ({
    type: TypeActionShop.RequestUpdate,
}); };
export var actionShopCharacteristicsReceived = function (characteristics) { return ({
    characteristics: characteristics,
    type: TypeActionShop.CharacteristicsReceived,
}); };
export var actionShopCatalogReceived = function (catalog) { return ({
    catalog: catalog,
    type: TypeActionShop.CatalogReceived,
}); };
export var actionShopShiftLevelReceived = function (shiftLevel) { return ({
    shiftLevel: shiftLevel,
    type: TypeActionShop.ShiftLevelReceived,
}); };
export var actionShopRequestShiftLevelUpdate = function () { return ({
    type: TypeActionShop.RequestShiftLevelUpdate,
}); };
export var actionShopUpdateShiftLevel = function () { return ({
    type: TypeActionShop.UpdateShiftLevel,
}); };
export var actionShopRequestPurchase = function (offer, selectedProvider) { return ({
    offer: offer,
    selectedProvider: selectedProvider,
    type: TypeActionShop.RequestPurchase,
}); };
export var actionShopSelectOffer = function (selectedOfferInfo) { return ({
    selectedOfferInfo: selectedOfferInfo,
    type: TypeActionShop.SelectOffer,
}); };
export var actionShopDeselectOffer = function () { return ({
    type: TypeActionShop.SelectOffer,
}); };
export var actionShopOpenOffer = function (offerCharacteristicId) { return ({
    offerCharacteristicId: offerCharacteristicId,
    type: TypeActionShop.OpenOffer,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/actionShop.ts
// module id = 80
// module chunks = 3